import { render, staticRenderFns } from "./session-handler.vue?vue&type=template&id=7912c75f"
import script from "./session-handler.vue?vue&type=script&lang=js"
export * from "./session-handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports